const translations = {
  "en": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/mo)",
    "and": "and",
    "Answers built on your unique history": "Answers built on your unique history",
    "By subscribing, you agree to our": "By subscribing, you agree to our",
    "Earnings Forecast": "Earnings Forecast",
    "Ed already is.": "Ed already is.",
    "Ed Complete Annual": "Ed Complete Annual",
    "Ed does that for you": "Ed does that for you",
    "Flag risks before they land": "Flag risks before they land",
    "IPO Strategies": "IPO Strategies",
    "Just Look around": "Just Look around",
    "Let Ed analyze the data for you": "Let Ed analyze the data for you",
    "Monitors your portfolio while you're away": "Monitors your portfolio while you're away",
    "No charges if canceled within 7 days": "No charges if canceled within 7 days",
    "Offer Ends": "Offer Ends",
    "Privacy Policy": "Privacy Policy",
    "Purchase failed.": "Purchase failed.",
    "Return over the past 6 months for unlockers:": "Return over the past 6 months for unlockers:",
    "Start Your 7-Day Free Trial": "Start Your 7-Day Free Trial",
    "Subscribe now": "Subscribe now",
    "Terms of Use": "Terms of Use",
    "This signal could earn you": "This signal could earn you",
    "Trial Offer Ends In": "Trial Offer Ends In",
    "Try 7 Days for Just $%{var0}": "Try 7 Days for Just $%{var0}",
    "Unlock": "Unlock",
    "View all plans": "View all plans",
    "You shouldn't have to watch the markets alone": "You shouldn't have to watch the markets alone"
  },
  "zh-tw": {
    "(≈$%{var0}/mo)": "(≈$%{var0}/月)",
    "and": "和",
    "Answers built on your unique history": "答案建立在你的專屬歷史紀錄上",
    "By subscribing, you agree to our": "訂閱即表示你同意我們的",
    "Earnings Forecast": "財報預測",
    "Ed already is.": "Ed 已經是了。",
    "Ed Complete Annual": "Ed Complete 年度",
    "Ed does that for you": "Ed 為你搞定",
    "Flag risks before they land": "在風險發生前預先警示",
    "IPO Strategies": "IPO 策略",
    "Just Look around": "我想先四處看看",
    "Let Ed analyze the data for you": "讓 Ed 為你分析資料",
    "Monitors your portfolio while you're away": "在你離開時監控你的投資組合",
    "No charges if canceled within 7 days": "如於 7 天內取消，將不收取費用",
    "Offer Ends": "優惠截止",
    "Privacy Policy": "隱私權政策",
    "Purchase failed.": "購買失敗。",
    "Return over the past 6 months for unlockers:": "解鎖者過去 6 個月的報酬：",
    "Start Your 7-Day Free Trial": "開始你的 7 天免費試用",
    "Subscribe now": "立即訂閱",
    "Terms of Use": "使用條款",
    "This signal could earn you": "這個訊號可能為你帶來",
    "Trial Offer Ends In": "試用優惠倒數",
    "Try 7 Days for Just $%{var0}": "試用 7 天僅需 $%{var0}",
    "Unlock": "解鎖",
    "View all plans": "查看所有方案",
    "You shouldn't have to watch the markets alone": "你不應該獨自關注市場動態"
  }
};

export default translations;
